<template>
  <component :is="as" class="app-brand-wordmark" :class="sizeClass">
    {{ APP_BRAND.prefix }}<span class="app-brand-accent">{{ APP_BRAND.accent }}</span>
  </component>
</template>

<script setup>
import { computed } from 'vue'
import { APP_BRAND } from '@/config/appBrand'

const props = defineProps({
  as: {
    type: String,
    default: 'span'
  },
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md', 'lg'].includes(value)
  }
})

const sizeClass = computed(() => `size-${props.size}`)
</script>

<style scoped>
.app-brand-wordmark {
  margin: 0;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--text-primary, #1a2332);
  line-height: 1.1;
}

.size-sm {
  font-size: 1rem;
}

.size-md {
  font-size: 1.35rem;
}

.size-lg {
  font-size: 2rem;
}

.app-brand-accent {
  color: var(--primary-color, #1976d2);
}
</style>
